/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */
import { apiFetch } from '../../../../apiClient';

const i18nServerDomain = "/api/locale/";

export const getMessage = (url, key = null) => dispatch => {
    if (key === null) key = url
    return apiFetch(`${i18nServerDomain}${url}`)(dispatch)
        .then(data => {
            key && dispatch({ type: "GET_MESSAGE", payload: { [key]: data } });
            return data;
        })
        .catch(error => {
            throw error;
        });
}



// WEBPACK FOOTER //
// ./src/shared/containers/IntlProvider/state/actions.js